// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__18tSU","approved":"Status_approved__244RR","rejected":"Status_rejected__3bQBD","expired":"Status_expired__RxRoT","label":"Status_label__3wS9p"};